import React from "react";
import { cn } from "../../../lib/utils";

export const Skeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("animate-pulse rounded-lg bg-slate-200/70", className)} />
);

interface DashCardProps {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

export const DashCard: React.FC<DashCardProps> = ({
  title,
  subtitle,
  action,
  className,
  bodyClassName,
  children,
}) => (
  <section
    className={cn(
      "flex flex-col rounded-2xl border border-slate-200/80 bg-white shadow-[0_1px_2px_rgba(16,24,40,0.04)]",
      className
    )}
  >
    {(title || action) && (
      <header className="flex items-start justify-between gap-3 px-5 pt-5">
        <div className="min-w-0">
          {title && (
            <h3 className="text-[15px] font-semibold text-slate-900">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>
          )}
        </div>
        {action}
      </header>
    )}
    <div className={cn("flex-1 p-5", bodyClassName)}>{children}</div>
  </section>
);

interface EmptyStateProps {
  icon: React.ReactNode;
  message: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, message }) => (
  <div className="flex flex-col items-center justify-center gap-2 py-10 text-center">
    <div className="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-slate-400">
      {icon}
    </div>
    <p className="text-sm text-slate-500">{message}</p>
  </div>
);
